module.exports = __webpack_public_path__ + "static/visa-f1d239db2638fdac7ccf20e99ad161cf.png";